import { Box, Skeleton, Stack } from '@mui/material';

const Dish = () => (
  <Stack direction="row" gap={3} flex={1}>
    <Skeleton variant="rounded" sx={{ height: 100, width: 100 }} />
    <Stack gap={1} flex={1}>
      <Stack direction="row" justifyContent="space-between" gap={2}>
        <Skeleton variant="text" sx={{ height: 40, width: '60%' }} />
        <Skeleton variant="text" sx={{ height: 40, width: '50px' }} />
      </Stack>
      <Stack gap={0} flex={1}>
        <Skeleton variant="text" sx={{ height: 20, width: '100%' }} />
        <Skeleton variant="text" sx={{ height: 20, width: '80%' }} />
      </Stack>
    </Stack>
  </Stack>
)

const MenuSkeleton = () => {
  return (
    <Box
      sx={{
        height: '100vh',
        p: 3,
        gap: 2,
        display: 'flex',
        flexDirection: 'column',
      }}
    >

    <Stack gap={5}>
      <Stack gap={2}>
        <Skeleton variant="text" sx={{ height: 50, width: '60%' }} />
        <Stack gap={3}>
          <Dish/>
          <Dish/>
          <Dish/>
        </Stack>
      </Stack>
      <Stack gap={2}>
        <Skeleton variant="text" sx={{ height: 50, width: '60%' }} />
        <Dish/>
      </Stack>
    </Stack>
      
    </Box>
  );
};

export default MenuSkeleton;
